import { render, staticRenderFns } from "./Sparkles.vue?vue&type=template&id=7f3b9e49&scoped=true&"
import script from "./Sparkles.vue?vue&type=script&lang=js&"
export * from "./Sparkles.vue?vue&type=script&lang=js&"
import style0 from "./Sparkles.vue?vue&type=style&index=0&id=7f3b9e49&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f3b9e49",
  null
  
)

export default component.exports